export default "__VITE_ASSET__C94JuR0G__"